export enum FilterExpressionType {
    equals = "equals",
    contains = "contains",
    lessThan = "lessThan",
    greaterThan = "greaterThan"
}
